// Users-specific validation - Uses generic validation utility
import { createValidation } from '../../utils/validation';

/**
 * Users-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing users module code
 */
export const createUsersValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return the same interface but with users-specific method names
  return {
    schema: validation.schema,
    validateData: validation.validateData, // Standardized method name
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createUsersValidation;
